
import { wakeAudio, wireUnlock } from './audioEngine';

let wired = false;

export function initAudioSession(): void {
  if (wired || typeof window === 'undefined') return;
  wired = true;
  wireUnlock();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) wakeAudio();
  });
  // WHY: visibilitychange skips window switches and bfcache returns, which also come back with a closed context — wake on
  // focus + pageshow
  window.addEventListener('focus', wakeAudio);
  window.addEventListener('pageshow', wakeAudio);
}
